import { Dropdown, Tooltip, type MenuProps } from "antd";
import { MenuSvgIcon } from "./MenuSvgIcon";

export interface RightMenuProps {
    onCloseOthers: () => void;
    onCloseAll: () => void;
}

/** 标签栏右侧历史页签菜单。 */
export function RightMenu({ onCloseOthers, onCloseAll }: RightMenuProps) {
    const items: MenuProps["items"] = [
        { key: "close-others", label: "关闭其它", onClick: onCloseOthers },
        { key: "close-all", label: "关闭所有", onClick: onCloseAll }
    ];

    return (
        <Dropdown trigger={["click"]} menu={{ items }}>
            <span className="tabs-control">
                {/* 右侧控制按钮贴近视口边缘，右对齐可避免 Tooltip 向右溢出造成横向滚动。 */}
                <Tooltip title="关闭历史页签" placement="bottomRight">
                    <button type="button" className="right-menu-icon" aria-label="关闭历史页签">
                        <MenuSvgIcon />
                    </button>
                </Tooltip>
            </span>
        </Dropdown>
    );
}

export default RightMenu;
